import styles from "./styles.module.scss";
import React, { FunctionComponent } from "react";
import { Card, CardActionArea, Stack, useTheme } from "@mui/material";
import { Icon, IconType } from "../../../../icons";

export const OriginCountryCard: FunctionComponent<IOriginCountryCardProps> = ({
  name,
  isoCode,
  emoji,
  selected,
  onClick,
  onContextMenu
}) => {
  const theme = useTheme();
  return (
    <Card className={styles.container} sx={{ height: 60 }} elevation={5}>
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row"
        }}
        style={{
          borderColor: theme.palette.colors?.highlightBorder,
          borderWidth: 4,
          borderStyle: selected ? "double" : "none"
        }}
        onContextMenu={onContextMenu}
        onClick={onClick}
      >
        <Card className={styles.defaultIcon}>
          {emoji ? (
            <Stack alignItems={"center"}>
              <p className={styles.flag}>{emoji}</p>
              {isoCode !== "XXX" && <p className={styles.isoCode}>{isoCode}</p>}
            </Stack>
          ) : (
            <Icon type={IconType.Flag} />
          )}
        </Card>
        <Stack className={styles.rightContainer} spacing={1}>
          <p className={styles.name}>{name}</p>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export interface IOriginCountryCardProps {
  name: string;
  isoCode?: string;
  emoji?: string;
  selected?: boolean;
  onClick: (event: React.MouseEvent) => void;
  onContextMenu: (event: React.MouseEvent) => void;
}
